var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHpdNavigationIcon = function SvgHpdNavigationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    stroke: "#fff",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hpd-navigation-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.16 12.207a5.829 5.829 0 0 1-.645.702v3.437a1.137 1.137 0 0 1-2.274 0v-2.973a5.228 5.228 0 0 0 3.383-4.885V7.074a2.289 2.289 0 0 0-1.147-1.588 2.243 2.243 0 0 0-1.099-.28 2.286 2.286 0 0 0-2.282 2.282v4.182c.072-.016.145-.034.214-.054.054-.016.108-.032.16-.05.011-.006.024-.009.036-.014a2.798 2.798 0 0 0 .365-.157c.06-.031.13-.07.19-.107l.01-.007c.052-.031.1-.06.15-.097a.06.06 0 0 0 .021-.014V7.488a1.141 1.141 0 0 1 1.419-1.103 1.14 1.14 0 0 1 .819.816V8.49a4.077 4.077 0 0 1-3.387 4.013 4.024 4.024 0 0 1-1.31.013 4.077 4.077 0 0 1-3.42-3.483V7.488a1.14 1.14 0 0 1 1.136-1.141 1.14 1.14 0 0 1 1.139 1.14v3.737c.114.073.233.14.355.198.098.049.198.092.3.13l.087.03c.023.007.046.014.067.022l.107.03.115.029.114.024v-4.2a2.286 2.286 0 0 0-2.637-2.253 2.285 2.285 0 0 0-1.93 2.254v1.62a5.228 5.228 0 0 0 3.422 4.294v2.942a1.137 1.137 0 0 1-2.274 0v-3.368a6.207 6.207 0 0 1-1.149-1.388v4.76a2.284 2.284 0 0 0 4.568 0v-2.675a5.115 5.115 0 0 0 1.31-.008v2.682a2.284 2.284 0 1 0 4.567 0v-4.889a6.034 6.034 0 0 1-.5.749Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hpd-navigation-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.217 5.203)",
    d: "M0 0h10.445v13.427H0z"
  })))));
};
export default SvgHpdNavigationIcon;